import React from 'react';
import BentoCard from '../layout/BentoCard';
import { profile } from '../../data/profile';

/**
 * ExperienceSection - Location and experience display
 */
const ExperienceSection = () => {
  return (
    <BentoCard span="1" delay={250}>
      <div className="p-6 h-full flex flex-col justify-between">
        <div>
          <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <span style={{ color: 'var(--color-accent)' }}>📍</span>
            Currently working in
          </h2>
          <p className="text-2xl font-bold">{profile.currently}</p>
          <p
            className="text-sm mt-1"
            style={{ color: 'var(--color-text-muted)' }}
          >
            Available for remote work globally
          </p>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <span style={{ color: 'var(--color-accent)' }}>📍</span>
            Based in
          </h2>
          <p className="text-2xl font-bold">{profile.location}</p>
        </div>

        <div
          className="mt-4 pt-4 md:mt-6 md:pt-6 border-t"
          style={{ borderColor: 'var(--color-border)' }}
        >
          <div className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
            Experience
          </div>
          <div
            className="text-3xl font-bold font-mono"
            style={{ color: 'var(--color-accent)' }}
          >
            {profile.experience}
          </div>
        </div>
      </div>
    </BentoCard>
  );
};

export default ExperienceSection;
